package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.entities.Parashot
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.BrowseMode
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.ShonotEntry
import com.eladfinish.bible.contest.screens.browse.usecases.chumash.GetContentForChumashModeUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.shonot.GetShonotContentUseCase

class FetchChapterDataUseCase(
    private val getContentForBibleModeUseCase: GetContentForBibleModeUseCase,
    private val getContentForChumashModeUseCase: GetContentForChumashModeUseCase,
    private val getContentForSedarimModeUseCase: GetContentForSedarimModeUseCase,
    private val getShonotContentUseCase: GetShonotContentUseCase,
) {

    operator fun invoke(
        browseMode: BrowseMode,
        bookIndex: Int,
        partIndex: Int,
        cachedParashot: Parashot?,
        deceasedName: String? = null,
    ): ChapterData {
        return when (browseMode) {
            BrowseMode.BIBLE_MODE -> {
                getContentForBibleModeUseCase(
                    bookIndex = bookIndex,
                    partIndex = partIndex,
                )
            }

            BrowseMode.CHUMASH_MODE -> {
                getContentForChumashModeUseCase(
                    bookIndex = bookIndex,
                    partIndex = partIndex,
                    cachedParashot = requireNotNull(cachedParashot),
                )
            }

            BrowseMode.SEDARIM_MODE -> {
                getContentForSedarimModeUseCase(
                    bookIndex = bookIndex,
                    partIndex = partIndex,
                )
            }

            // No book edges in this mode, so the parts are numbered from 0.
            BrowseMode.SHONOT_MODE -> {
                getShonotContentUseCase(
                    entry = ShonotEntry.entries[partIndex],
                    deceasedName = deceasedName,
                )
            }
        }
    }
}
